import {BaseModel} from "./base-model";

export class SelectionEntityModel extends BaseModel {
  id: Number;
  type: String;
  date: Date;
  source: String;

  constructor(id: Number, type: String, date: String, source: String) {
    super();

    this.id = id;
    this.type = type;
    this.date = date;
    this.source = source;
  }

  equals(model: SelectionEntityModel): * {
    const isObjectTypeEquals = this.type === model.type;
    const isIdsEquals = this.id === model.id;

    return isObjectTypeEquals && isIdsEquals;
  }
}


